/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import InfoIcon from '@mui/icons-material/PermDeviceInformationTwoTone';
import * as React from 'react';
import AlertDialog from './Message';

interface Props {
    dialogContent: any;
    handleOk: Function;
}

class NewUserDialog extends React.Component<Props, any>{
  state = {
    alertOpen: true
  };

  handleAlertOk = () => {
    this.props.handleOk();
    this.setState({
      alertOpen: false
    });
   };

  render() {
    const dialogTitle = <div> <InfoIcon /> Information </div>;
    return (
        <div>          
          <AlertDialog dialogContent={this.props.dialogContent} dialogTitle={dialogTitle}
          handleClose={this.handleAlertOk} open={this.state.alertOpen} handleOk={this.handleAlertOk} noCancelButton={true}/>
        </div> 

    );
  }
}
export default NewUserDialog;
